import { useEffect, useRef, useState } from "react";
const { hasRequiredAlternanceAcceptance } = require("../shared/progress");
function escapeAttributeValue(value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

export default function Navbar2({ getBtnRetourActif, getBtnSoumissionActif, getBtnSoumissionDossier, getMainActifNum, setMainActifNum, getNumberFiliereActif, setNumberCritereActif, setNumberSousCritereActif, data, isDisabled, setsendToCrmValue, Lang, token, sendToCrmValueOrigin, triggerSave, recordNav, submitCandidatureToCrm }) {


  const [submittingExchange, setSubmittingExchange] = useState(false);
  const [exchangeError, setExchangeError] = useState('');
  const [getBtnOui, setBtnOui] = useState("Oui");
  const [getBtnNon, setBtnNon] = useState("Non");
  const [getEtesVousSur, setEtesVousSur] = useState("Êtes-vous sûr de vouloir envoyer votre dossier? Vous ne pourrez plus faire de modifications ultérieurement.");

  // Envoi d'une candidature au CRM : l'aller-retour REST dure plusieurs
  // secondes et rien ne bougeait à l'écran. On affiche un voile d'attente et
  // on verrouille les boutons le temps que Salesforce réponde.
  // La garde est un ref, pas l'état : les boutons de l'écran de confirmation
  // sont câblés par addEventListener, leur closure ne verrait pas l'état.
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);

  // Une candidature s'envoie filière par filière : la confirmation la nomme.
  const currentEntry = data?.data?.[getNumberFiliereActif];
  const filiereLabel = [currentEntry?.niveau, currentEntry?.nom].filter(Boolean).join(' - ');

  useEffect(() => {
    setBtnOui(Lang === "en" ? "Yes" : "Oui");
    setBtnNon(Lang === "en" ? "No" : "Non");
    // Les candidatures n'ont plus d'étape de paiement : l'avertissement de non-retour
    // est renforcé puisque ce clic est la dernière barrière avant l'envoi.
    if (data?.configuration === 'Candidature') {
      setEtesVousSur(Lang === "en"
        ? `Are you sure you want to submit your application${filiereLabel ? ` for "${filiereLabel}"` : ''}? This is final: you will not be able to go back or make any changes to this application. If you have the slightest doubt, click "No" to review all your information and documents one last time.`
        : `Êtes-vous sûr de vouloir envoyer votre candidature${filiereLabel ? ` pour « ${filiereLabel} »` : ''} ? Cet envoi est définitif : vous ne pourrez plus revenir en arrière ni modifier quoi que ce soit pour cette filière. Si vous avez le moindre doute, cliquez sur « Non » pour relire une dernière fois l'ensemble de vos informations et de vos documents.`);
    } else {
      setEtesVousSur(Lang === "en" ? "Are you sure you want to submit your application? You will not be able to make any changes later." : "Êtes-vous sûr de vouloir envoyer votre dossier? Vous ne pourrez plus faire de modifications ultérieurement.");
    }

  }, [Lang, data?.configuration, filiereLabel]);

  /* ---  SOUMISSION D'UN DOSSIER --- */

  //Empêche getMainActifNum < 0
  const handleClickDecreGetMain = () => {
    triggerSave(); // SAVE ON BACK
    if (getMainActifNum === 4) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(1);
    } else if (getMainActifNum !== 0) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(getMainActifNum - 1);
    }
  }

  async function nextEtape(event) {
    event?.preventDefault();
    if (submittingRef.current) return;
    if (data?.configuration === 'Echange') {
      if (submittingExchange || isDisabled || !window.confirm(getEtesVousSur)) return;
      setSubmittingExchange(true);
      setExchangeError('');
      try {
        const response = await fetch('/backend/api/exchange-student/submit', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, newData: data })
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Unable to submit your application. Please try again.');
        window.location.reload();
      } catch (error) {
        setExchangeError(error.message);
        setSubmittingExchange(false);
      }
      return;
    }
    if (getMainActifNum >= 2 && !hasRequiredAlternanceAcceptance(data?.data?.[getNumberFiliereActif])) {
      return;
    }
    if (getMainActifNum !== 3) triggerSave(); // SAVE ON NEXT
    if (getMainActifNum === 1) {
      if (recordNav) {
        recordNav();
      }
      // Les candidatures n'ont plus d'étape « Validation du dossier » (critère 50) :
      // on passe directement à l'écran de confirmation avant envoi.
      if (data?.configuration === 'Candidature') {
        setMainActifNum(3);
        await generatesendToCrmValue();
        return;
      }
      setMainActifNum(2);
      setNumberCritereActif(data.data[getNumberFiliereActif].criteres.length - 1);
      setNumberSousCritereActif(0);
    } else if (getMainActifNum === 2) {
      if (recordNav) {
        recordNav();
      }
      setMainActifNum(3);
      await generatesendToCrmValue();
    } else if (getMainActifNum === 3) {
      if (recordNav) {
        recordNav();
      }

      // CANDIDATURES : envoi par l'API REST, côté serveur.
      // Le dossier n'est verrouillé qu'une fois Salesforce ayant confirmé ;
      // en cas de refus, le candidat revient au formulaire avec les champs
      // fautifs signalés. Les inscriptions utilisent Web-to-Case côté serveur.
      if (data?.configuration === 'Candidature' && submitCandidatureToCrm) {
        // Un envoi est déjà en cours : on ignore le clic plutôt que de créer
        // une seconde Demande dans le CRM.
        if (submittingRef.current) {
          return;
        }
        submittingRef.current = true;
        setIsSubmitting(true);
        let accepted = false;
        try {
          accepted = await submitCandidatureToCrm();
        } finally {
          submittingRef.current = false;
          setIsSubmitting(false);
        }
        if (!accepted) {
          // Refus : on reste sur le formulaire, rien n'est verrouillé.
          return;
        }
        setMainActifNum(4);
        return;
      }

      submittingRef.current = true;
      setIsSubmitting(true);
      setExchangeError('');
      try {
        const saved = await fetch('/backend/update-json', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ etudiant: token, newData: data })
        });
        if (!saved.ok) throw new Error('Impossible d’enregistrer vos réponses. Veuillez réessayer.');
        const response = await fetch('/backend/api/dossier/submit-salesforce', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, entryIndex: getNumberFiliereActif })
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Impossible de soumettre le dossier.');
        window.location.reload();
      } catch (error) { setExchangeError(error.message); }
      finally { submittingRef.current = false; setIsSubmitting(false); }
    } else if (getMainActifNum === 4) {
      if (Array.isArray(data?.data) && data.data[getNumberFiliereActif]) {
        data.data[getNumberFiliereActif].soumis = false;
      }
    }
  }

  useEffect(() => {
    const btnNon = document.getElementById("btnNon");
    const btnOui = document.getElementById("btnOui");

    //console.log("BTNOUI")
    if (btnNon) {
      btnNon.addEventListener("click", handleClickDecreGetMain);
    }

    if (btnOui) {
      btnOui.addEventListener("click", nextEtape);
    }

    // Nettoyage au démontage
    return () => {
      if (btnNon) {
        btnNon.removeEventListener("click", handleClickDecreGetMain);
      }
      if (btnOui) {
        btnOui.removeEventListener("click", nextEtape);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendToCrmValueOrigin, data, getMainActifNum, getNumberFiliereActif, token, Lang, submitCandidatureToCrm]);

  // Les boutons « Oui » / « Non » de l'écran de confirmation sont injectés en
  // HTML brut : React ne les rend pas, on agit donc sur le DOM directement.
  useEffect(() => {
    const boutons = [document.getElementById("btnOui"), document.getElementById("btnNon")];
    boutons.forEach((bouton) => {
      if (!bouton) return;
      bouton.disabled = isSubmitting;
      bouton.classList.toggle("boutonConfirmationEnvoiEnCours", isSubmitting);
    });
  }, [isSubmitting, sendToCrmValueOrigin]);

  async function generatesendToCrmValue() {
    if (data?.configuration === 'Echange') return;
    setsendToCrmValue(`<div class="containerConfirmation">
      <h1>${escapeAttributeValue(getEtesVousSur)}</h1>
      <div class="boutonsConfirmation">
        <input type="button" id="btnNon" value="${escapeAttributeValue(getBtnNon)}">
        <input type="button" id="btnOui" value="${escapeAttributeValue(getBtnOui)}">
      </div>
    </div>`);
  }

  /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */



  return (
    <div className="BoutonsNavMain">
      {exchangeError && <p role="alert">{exchangeError}</p>}

      {isSubmitting && (
        <div className="voileEnvoiCrm" role="alert" aria-busy="true" aria-live="assertive">
          <div className="voileEnvoiCrmContenu">
            <div className="voileEnvoiCrmSpinner" aria-hidden="true"></div>
            <p className="voileEnvoiCrmTitre">
              {Lang === "en" ? "Submitting your application…" : "Envoi de votre dossier en cours…"}
            </p>
            <p className="voileEnvoiCrmDetail">
              {Lang === "en"
                ? "Please wait while we confirm your submission. Do not close this page."
                : "Merci de patienter pendant la confirmation de votre envoi. Ne fermez pas cette page."}
            </p>
          </div>
        </div>
      )}

      <button className={getBtnRetourActif} onClick={handleClickDecreGetMain} disabled={isSubmitting}>
        <p>{Lang === "en" ? "Back" : "Retour"}</p>
      </button>
      <button id="BoutonSoumission" onClick={nextEtape} disabled={isSubmitting || isDisabled || submittingExchange} className={getBtnSoumissionActif}><p>{data?.configuration === 'Echange' ? (submittingExchange ? "Submitting…" : "Submit my file") : (isSubmitting ? (Lang === "en" ? "Submitting…" : "Envoi en cours…") : getBtnSoumissionDossier)}</p></button>

    </div>
  );
}
